import { toast, ToastOptions, ToastContentProps } from "react-toastify";
import { CheckCircleOutlined, ErrorOutline, WarningAmberOutlined } from "@mui/icons-material";
import Box from "@mui/material/Box";

type Status = "success" | "error" | "warning" | "info";

interface ToastMessageProps extends Partial<ToastContentProps> {
    message: string;
    status: Status;
}


const ToastMessage = ({ message, status }: ToastMessageProps) => {
    const getIcon = () => {
        switch (status) {
            case "success":
                return <CheckCircleOutlined />;
            case "warning":
                return <WarningAmberOutlined />;
            case "error":
            default:
                return <ErrorOutline />;
        }
    };

    return (
        <Box display="inline-flex" alignItems="center" color="white">
            {getIcon()}
            <Box ml="0.5em">{message}</Box>
        </Box>
    );
};

// Helper functions
export const toastSuccess = (message: string, options?: ToastOptions) => {
    toast.success(<ToastMessage message={message} status="success" />, {
        position: "bottom-center",
        draggable: false,
        ...options,
    });
};

export const toastInfo = (message: string, options?: ToastOptions) => {
    toast.info(<ToastMessage message={message} status="info" />, {
        position: "bottom-center",
        draggable: false,
        ...options,
    });
};

export const toastError = (message: string, options?: ToastOptions) => {
    toast.error(<ToastMessage message={message} status="error" />, {
        position: "bottom-center",
        draggable: false,
        ...options,
    });
};

export const toastWarning = (message: string, options?: ToastOptions) => {
    toast.warning(<ToastMessage message={message} status="warning" />, {
        position: "bottom-center",
        draggable: false,
        ...options,
    });
};
